/**
 * Typewriter Animation Module
 * Animates cycling through words with typewriter effect
 */

import { $ } from '../utils/dom.js';

export class Typewriter {
    constructor() {
        this.element = $('.hero-title .typewriter-text');
        this.words = ['streamlines', 'organizes', 'simplifies', 'structures'];
        this.currentWordIndex = 0;
        this.currentText = '';
        this.isDeleting = false;
        this.typeSpeed = 100;
        this.deleteSpeed = 50;
        this.delayBetweenWords = 2000;

        if (this.element) {
            this.init();
        }
    }

    init() {
        // Start the typewriter animation
        this.type();
    }

    type() {
        const currentWord = this.words[this.currentWordIndex];

        if (this.isDeleting) {
            // Delete text
            this.currentText = currentWord.substring(0, this.currentText.length - 1);
        } else {
            // Type text
            this.currentText = currentWord.substring(0, this.currentText.length + 1);
        }

        // Update the element
        this.element.textContent = this.currentText;

        // Determine next action
        let nextDelay = this.isDeleting ? this.deleteSpeed : this.typeSpeed;

        if (!this.isDeleting && this.currentText === currentWord) {
            // Finished typing current word, wait then delete
            nextDelay = this.delayBetweenWords;
            this.isDeleting = true;
        } else if (this.isDeleting && this.currentText === '') {
            // Finished deleting, move to next word
            this.isDeleting = false;
            this.currentWordIndex = (this.currentWordIndex + 1) % this.words.length;
            nextDelay = 500; // Small pause before typing next word
        }

        setTimeout(() => this.type(), nextDelay);
    }

    destroy() {
        // Cleanup if needed
    }
}
